import { render, staticRenderFns } from "./validation-summary.vue?vue&type=template&id=2ac01fb1&"
import script from "./validation-summary.vue?vue&type=script&lang=ts&"
export * from "./validation-summary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports